<template>
    <div>
        <section id="demo" class="demo observer-fade bg-none">
            <div class="container">
                <div class="demo-container split two-col bg-none">
                    <div class="demo-content line">
                        <h2>Stay informed</h2> 
                        <p>
                            <strong>Spend less time guessing how you perform</strong>. Rely on our real-time dashboard analytics. tay informed with our flexible reporting tool.
                        </p>
                    </div>

                    <div class="img-blur-outer">
                        <div class="img-blur">
                            <img src="@/assets/img/reports_two.svg" alt="reports image">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="problems border-0 observer-fade bg-none">
            <div class="container">
                <div class="demo-container md">
                    <div class="demo-content mb--15">
                        <h2>Know. Measure. Identify.</h2> 
                    </div>
                    
                    <div class="demo-container img one-col bg-none p-0">    
                        <div class="grid gap-3 reports-demo-wrap">
                            <div v-for="item in reports" :key="item.name" class="reports-demo">
                                <h2>{{ item.name }}</h2>
                                <p>{{ item.desc }}</p>
                            </div>
                        </div>                  
                    </div>
                </div>
            </div>
        </section>

        <section id="demo" class="demo observer-fade bg-none">
            <div class="container">
                <div class="demo-container two-col split bg-none">
                    <div class="demo-visual bg-transparent gap-3 grid p-4 w-100">
                        <img src="@/assets/img/report_download.svg" class="h--100 w-100" alt="report download image">
                    </div>

                    <div class="demo-content right-line">
                        <h2>Insights into your data at your disposal</h2> 
                        <p>
                            Simple, intuitive dashboard reports for easy analysis. Filter data by date ranges, features, and custom parameters (coming soon).
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="problems border-0 observer-fade bg-none">
            <div class="container">
                <div class="demo-container full">
                    <div class="demo-content line mb--35">
                        <h2>Visualize. Customize. Export</h2> 
                        <p>
                            Go beyond basic metrics with trend analysis, forecasting, and statistical insights that show deeper patterns in your work. Build reports that fit your workflow with filters, grouping, and date ranges.
                        </p>
                    </div>
                    
                    <div class="demo-container img one-col bg-none p-0">
                        <div class="demo-header">
                            <div class="traffic-light red" />
                            <div class="traffic-light yellow" />
                            <div class="traffic-light green" />
                            <div class="demo-title">
                                Project Alpha - Sprint 3
                            </div>
                        </div>
                        
                        <div class="tasks-demo">
                            <img src="@/assets/img/reports_three.svg" alt="sample of reports image">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "ProductReportsPage",

    data() {
        return {
            reports: [
                { id: "clients", name: "Know your clients", desc: "See who your most active or highest paying clients are. Get data to compare metrics like the number of active vs potential leads within a certain period." },
                { id: "projects", name: "Measure project delivery", desc: "Audit your project delivery performance for productivity and growth tracking. Get stats like your highest paying or most time intensive projects." },
                { id: "invoices", name: "Identify revenue trends", desc: "Being able to visualize the frequency at which invoices get paid can help for better cashflow optimization." },
            ],
            observer: null,
        };
    },

    async mounted() {
        this.initPageIntersectionObserver();
    },
    
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    
    methods: {
        handleGetStarted() {            
            this.$store.dispatch("app/setSelectedPlan", "free");
            this.$router.push("/auth/signup");
        },
        initPageIntersectionObserver() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: "0px 0px -50px 0px",
            });

            // Observe all elements with observer-fade class
            document.querySelectorAll(".observer-fade").forEach(el => {                
                this.observer.observe(el);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    section {
        margin-top: 0rem;
    }

    .demo-container {
        &.full {
            grid-template-columns: 1fr;
            max-width: 60%;
            margin: auto;
        }

        &.md {
            grid-template-columns: 1fr;
            max-width: 80%;
            margin: auto;
        }

        &.img {
            margin-top: 4rem;
        }
    }

    .tasks-demo {
        min-height: 250px;

        img {
            max-width: 100%;
            width: 100%;
        }
    }

    .reports-demo-wrap {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 2rem;
    }

    .reports-demo {
        color: #1e293b;

        h2 {
            font-size: 1.25rem;
            font-weight: 500;
        }

        p {
            font-size: .975rem;
            margin-top: 0.75rem;
            color: #4A5568;
            line-height: 24px;
            color: #64748b;
        }
    }

    .tasks-demo::after, .demo-visual::after {
        content: "";
        pointer-events: none;
        position: absolute;
        inset: 0;
        z-index: 2;
        background: linear-gradient(to bottom, transparent 50%, #faf9f5 100%);
        background: linear-gradient(to bottom, #ffffff21 50%, #faf9f5 100%);
    }
</style>